// Which zone a deep link (?zone=…&zk=…) points at — option A, phase 4.3.
//
// Notification and email links carry the zone's NAME for display and, since 4.1, its
// ZoneKey as `zk`. The name in a link is the one the zone had when the link was made,
// so after a rename only the key still finds it: the key wins when the zone directory
// knows it, else the name as written (older links, or a deleted zone).
//
// Pure (unit-tested); `nameOf(key)` is the ZoneDirectory store's getter.

export function zoneFromLink(query, nameOf) {
  const q = query || {}
  const key = q.zk != null && q.zk !== '' ? Number(q.zk) : null
  const current = key != null && Number.isFinite(key) && typeof nameOf === 'function'
    ? nameOf(key) : null
  if (current) return current
  return q.zone ? String(q.zone) : null
}
